export const FREE_PLAN_LIMITS = {
  MAX_CANDIDATES: 100,
  MAX_EMAILS: 100,
};
